<template>
  <div>
    <div v-if="valid === false" class="alert alert-soft-danger">
      <i class="fas fa-info-circle mt-1 mr-1"></i> {{ error }}
    </div>
  </div>
</template>

<script>
export default {
  name: "FormErrorAlert",
  
  props: {
    valid: Boolean,
    error: String,
    errors: Array
  }
}
</script>